<app-auth-modal-shell *ngIf="isVisible" title="Set up a new password" (closed)="closeModal()">
  <form class="create-password-modal__form" [formGroup]="createPasswordForm" (ngSubmit)="onSubmit()">
    <app-auth-password-field
      [control]="createPasswordForm.controls.password"
      [showInvalidHint]="false"
      autocomplete="new-password"
    />

    <div
      class="password-hints"
      *ngIf="isFocusPassword || (createPasswordForm.get('password')?.value?.length || 0) > 0"
    >
      <div class="password-hints__row">
        <div class="password-hints__item" [class.password-hints__item--valid]="validLength">
          <span class="password-hints__icon">
            <img *ngIf="validLength; else crossIcon" src="../../../assets/icons/check.svg" alt="Check" />
            <ng-template #crossIcon>
              <img src="../../../assets/icons/cross.svg" alt="Cross" />
            </ng-template>
          </span>
          8 characters minimum
        </div>

        <div class="password-hints__item" [class.password-hints__item--valid]="hasUpperCase">
          <span class="password-hints__icon">
            <img *ngIf="hasUpperCase; else crossIcon2" src="../../../assets/icons/check.svg" alt="Check" />
            <ng-template #crossIcon2>
              <img src="../../../assets/icons/cross.svg" alt="Cross" />
            </ng-template>
          </span>
          One uppercase letter
        </div>
      </div>

      <div class="password-hints__row">
        <div class="password-hints__item" [class.password-hints__item--valid]="hasNumber">
          <span class="password-hints__icon">
            <img *ngIf="hasNumber; else crossIcon3" src="../../../assets/icons/check.svg" alt="Check" />
            <ng-template #crossIcon3>
              <img src="../../../assets/icons/cross.svg" alt="Cross" />
            </ng-template>
          </span>
          One number
        </div>
      </div>
    </div>

    <app-auth-password-field
      [control]="createPasswordForm.controls.confirmPassword"
      placeholder="Repeat Password"
      [showInvalidHint]="false"
      autocomplete="new-password"
      [forceShowError]="confirmMismatchError"
    />
    <div *ngIf="confirmMismatchError" class="create-password-modal__error-text">Passwords do not match</div>

    <app-button variant="main" size="lg" [disabled]="isFormInvalid" [fullWidth]="true">
      <span *ngIf="isLoading" class="app-spinner app-spinner--on-inverse"></span>
      <span *ngIf="!isLoading">SET UP</span>
    </app-button>

    <div *ngIf="errorMessage" class="create-password-modal__error-text create-password-modal__error-message">
      {{ errorMessage }}
    </div>
  </form>
</app-auth-modal-shell>
